import { BASE_URL } from "@/constants";

export function getURLFunc(parentUrl: string) {
  return (link: string) => `${BASE_URL}${parentUrl}${link}`;
}
